// Bande d'environnement épinglée tout en haut de l'écran, AU-DESSUS de la navbar,
// pleine largeur et toujours visible (même en défilant). Le message défile en
// continu (marquee). Le reste de la mise en page (sidebar, navbar, contenu) est
// décalé vers le bas de RIBBON_H pour ne pas être recouvert.
// Production = https://poolins.oapps.net ; tout autre hôte = test.

const PROD_HOSTNAME = "poolins.oapps.net";
const RIBBON_H = 40; // hauteur de la bande (px) — synchronisée avec le décalage CSS

const EnvironmentBadge = () => {
    let hostname = "";
    try {
        hostname = window.location.hostname || "";
    } catch (e) {
        hostname = "";
    }

    const isProd = hostname === PROD_HOSTNAME;

    const config = isProd
        ? {
            bg: "#16a34a",
            message:
                "✓  ENVIRONNEMENT DE PRODUCTION  —  Données réelles : toutes les opérations sont définitives et historisées.",
        }
        : {
            bg: "#dc2626",
            message:
                `⚠  ENVIRONNEMENT DE TEST  ( ${hostname || "test"} )  —  Les données saisies ici ne sont pas réelles et peuvent être réinitialisées à tout moment. À ne pas utiliser pour des opérations réelles.`,
        };

    return (
        <>
            {/* Décale la mise en page sous la bande + animation du texte défilant. */}
            <style>{`
                .layout-page { padding-top: ${RIBBON_H}px !important; }
                .layout-wrapper aside { top: ${RIBBON_H}px !important; height: calc(100vh - ${RIBBON_H}px) !important; }
                .layout-page > nav { top: ${RIBBON_H}px !important; }
                /* Un peu d'air entre la navbar (sticky) et le contenu sur toutes les pages. */
                .layout-page > .content-wrapper { padding-top: 36px !important; }
                /* Évite que le contenu se colle sous la navbar lors du défilement. */
                .layout-page > .content-wrapper > .container-p-y { scroll-margin-top: ${RIBBON_H + 72}px; }

                .env-marquee { flex: 1; overflow: hidden; display: flex; }
                .env-marquee__track {
                    display: inline-flex;
                    white-space: nowrap;
                    will-change: transform;
                    animation: envMarquee 38s linear infinite;
                }
                .env-marquee:hover .env-marquee__track { animation-play-state: paused; }
                .env-marquee__track span { padding-right: 120px; }
                @keyframes envMarquee {
                    from { transform: translateX(0); }
                    to   { transform: translateX(-50%); }
                }
            `}</style>

            <div
                style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    right: 0,
                    height: RIBBON_H,
                    zIndex: 2000, // au-dessus de la sidebar (1000) et de la navbar (999)
                    background: config.bg,
                    color: "#ffffff",
                    display: "flex",
                    alignItems: "center",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.22)",
                    fontFamily: "system-ui, -apple-system, 'Segoe UI', sans-serif",
                    fontSize: 17,
                    fontWeight: 700,
                    letterSpacing: 0.4,
                }}
                title={isProd ? "Instance de production" : `Instance de test — ${hostname}`}
            >
                <div className="env-marquee">
                    {/* Texte dupliqué pour un défilement en boucle sans coupure. */}
                    <div className="env-marquee__track">
                        <span>{config.message}</span>
                        <span>{config.message}</span>
                    </div>
                </div>
            </div>
        </>
    );
};

export default EnvironmentBadge;
